import React from 'react';
import propTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

const { string, func } = propTypes;

function PhotoLightbox (props) {
	return (
		<div id='photo-lightbox'>
			<Lightbox
				mainSrc={props.mainSrc}
				prevSrc={props.prevSrc}
				nextSrc={props.nextSrc}
				imageTitle={props.imageTitle}
				onCloseRequest={props.onCloseRequest}
				onMovePrevRequest={props.onMovePrevRequest}
				onMoveNextRequest={props.onMoveNextRequest}
				imagePadding={50}
			/>
		</div>
	);
}

PhotoLightbox.propTypes = {
	mainSrc: string.isRequired,
	prevSrc: string,
	nextSrc: string,
	imageTitle: string.isRequired,
	onCloseRequest: func.isRequired,
	onMovePrevRequest: func,
	onMoveNextRequest: func
};

export default PhotoLightbox;
